!function (e) {
  if ("object" == typeof exports) module.exports = e();else if ("function" == typeof define && define.amd) define(e);else {
    var t;
    "undefined" != typeof window ? t = window : "undefined" != typeof global ? t = global : "undefined" != typeof self && (t = self), t.objectHash = e();
  }
}(function () {
  return function e(t, n, r) {
    function o(u, a) {
      if (!n[u]) {
        if (!t[u]) {
          var f = "function" == typeof require && require;
          if (!a && f) return f(u, !0);
          if (i) return i(u, !0);
          throw new Error("Cannot find module '" + u + "'");
        }

        var s = n[u] = {
          exports: {}
        };
        t[u][0].call(s.exports, function (e) {
          var n = t[u][1][e];
          return o(n ? n : e);
        }, s, s.exports, e, t, n, r);
      }

      return n[u].exports;
    }

    for (var i = "function" == typeof require && require, u = 0; u < r.length; u++) {
      o(r[u]);
    }

    return o;
  }({
    1: [function (e, t, n) {
      (function (r, o, i, u, a, f, s, c, l) {
        "use strict";

        function d(e, t) {
          return t = h(e, t), g(e, t);
        }

        function h(e, t) {
          if (t = t || {}, t.algorithm = t.algorithm || "sha1", t.encoding = t.encoding || "hex", t.excludeValues = !!t.excludeValues, t.algorithm = t.algorithm.toLowerCase(), t.encoding = t.encoding.toLowerCase(), t.ignoreUnknown = t.ignoreUnknown === !0, t.respectType = t.respectType !== !1, t.respectFunctionNames = t.respectFunctionNames !== !1, t.respectFunctionProperties = t.respectFunctionProperties !== !1, t.unorderedArrays = t.unorderedArrays === !0, t.unorderedSets = t.unorderedSets !== !1, t.unorderedObjects = t.unorderedObjects !== !1, t.replacer = t.replacer || void 0, t.excludeKeys = t.excludeKeys || void 0, "undefined" == typeof e) throw new Error("Object argument required.");

          for (var n = 0; n < v.length; ++n) {
            v[n].toLowerCase() === t.algorithm.toLowerCase() && (t.algorithm = v[n]);
          }

          if (v.indexOf(t.algorithm) === -1) throw new Error('Algorithm "' + t.algorithm + '"  not supported. supported values: ' + v.join(", "));
          if (m.indexOf(t.encoding) === -1 && "passthrough" !== t.algorithm) throw new Error('Encoding "' + t.encoding + '"  not supported. supported values: ' + m.join(", "));
          return t;
        }

        function p(e) {
          if ("function" != typeof e) return !1;
          var t = /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i;
          return null != t.exec(Function.prototype.toString.call(e));
        }

        function g(e, t) {
          var n;
          n = "passthrough" !== t.algorithm ? b.createHash(t.algorithm) : new w(), "undefined" == typeof n.write && (n.write = n.update, n.end = n.update);
          var r = y(t, n);
          if (r.dispatch(e), n.update || n.end(""), n.digest) return n.digest("buffer" === t.encoding ? void 0 : t.encoding);
          var o = n.read();
          return "buffer" === t.encoding ? o : o.toString(t.encoding);
        }

        function y(e, t, n) {
          n = n || [];

          var r = function r(e) {
            return t.update ? t.update(e, "utf8") : t.write(e, "utf8");
          };

          return {
            dispatch: function dispatch(t) {
              e.replacer && (t = e.replacer(t));
              var n = typeof t;
              return null === t && (n = "null"), this["_" + n](t);
            },
            _object: function _object(t) {
              var o = /\[object (.*)\]/i,
                  u = Object.prototype.toString.call(t),
                  a = o.exec(u);
              a = a ? a[1] : "unknown:[" + u + "]", a = a.toLowerCase();
              var f = null;
              if ((f = n.indexOf(t)) >= 0) return this.dispatch("[CIRCULAR:" + f + "]");
              if (n.push(t), "undefined" != typeof i && i.isBuffer && i.isBuffer(t)) return r("buffer:"), r(t);

              if ("object" === a || "function" === a) {
                var s = Object.keys(t);
                e.unorderedObjects && (s = s.sort()), e.respectType === !1 || p(t) || s.splice(0, 0, "prototype", "__proto__", "constructor"), e.excludeKeys && (s = s.filter(function (t) {
                  return !e.excludeKeys(t);
                })), r("object:" + s.length + ":");
                var c = this;
                return s.forEach(function (n) {
                  c.dispatch(n), r(":"), e.excludeValues || c.dispatch(t[n]), r(",");
                });
              }

              if (!this["_" + a]) {
                if (e.ignoreUnknown) return r("[" + a + "]");
                throw new Error('Unknown object type "' + a + '"');
              }

              this["_" + a](t);
            },
            _array: function _array(t, o) {
              o = "undefined" != typeof o ? o : e.unorderedArrays !== !1;
              var i = this;
              if (r("array:" + t.length + ":"), !o || t.length <= 1) return t.forEach(function (e) {
                return i.dispatch(e);
              });
              var u = [],
                  a = t.map(function (t) {
                var r = new w(),
                    o = n.slice(),
                    i = y(e, r, o);
                return i.dispatch(t), u = u.concat(o.slice(n.length)), r.read().toString();
              });
              return n = n.concat(u), a.sort(), this._array(a, !1);
            },
            _date: function _date(e) {
              return r("date:" + e.toJSON());
            },
            _symbol: function _symbol(e) {
              return r("symbol:" + e.toString());
            },
            _error: function _error(e) {
              return r("error:" + e.toString());
            },
            _boolean: function _boolean(e) {
              return r("bool:" + e.toString());
            },
            _string: function _string(e) {
              r("string:" + e.length + ":"), r(e.toString());
            },
            _function: function _function(t) {
              r("fn:"), p(t) ? this.dispatch("[native]") : this.dispatch(t.toString()), e.respectFunctionNames !== !1 && this.dispatch("function-name:" + String(t.name)), e.respectFunctionProperties && this._object(t);
            },
            _number: function _number(e) {
              return r("number:" + e.toString());
            },
            _xml: function _xml(e) {
              return r("xml:" + e.toString());
            },
            _null: function _null() {
              return r("Null");
            },
            _undefined: function _undefined() {
              return r("Undefined");
            },
            _regexp: function _regexp(e) {
              return r("regex:" + e.toString());
            },
            _uint8array: function _uint8array(e) {
              return r("uint8array:"), this.dispatch(Array.prototype.slice.call(e));
            },
            _uint8clampedarray: function _uint8clampedarray(e) {
              return r("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(e));
            },
            _int8array: function _int8array(e) {
              return r("uint8array:"), this.dispatch(Array.prototype.slice.call(e));
            },
            _uint16array: function _uint16array(e) {
              return r("uint16array:"), this.dispatch(Array.prototype.slice.call(e));
            },
            _int16array: function _int16array(e) {
              return r("uint16array:"), this.dispatch(Array.prototype.slice.call(e));
            },
            _uint32array: function _uint32array(e) {
              return r("uint32array:"), this.dispatch(Array.prototype.slice.call(e));
            },
            _int32array: function _int32array(e) {
              return r("uint32array:"), this.dispatch(Array.prototype.slice.call(e));
            },
            _float32array: function _float32array(e) {
              return r("float32array:"), this.dispatch(Array.prototype.slice.call(e));
            },
            _float64array: function _float64array(e) {
              return r("float64array:"), this.dispatch(Array.prototype.slice.call(e));
            },
            _arraybuffer: function _arraybuffer(e) {
              return r("arraybuffer:"), this.dispatch(new Uint8Array(e));
            },
            _url: function _url(e) {
              return r("url:" + e.toString(), "utf8");
            },
            _map: function _map(t) {
              r("map:");
              var n = Array.from(t);
              return this._array(n, e.unorderedSets !== !1);
            },
            _set: function _set(t) {
              r("set:");
              var n = Array.from(t);
              return this._array(n, e.unorderedSets !== !1);
            },
            _blob: function _blob() {
              if (e.ignoreUnknown) return r("[blob]");
              throw Error('Hashing Blob objects is currently not supported\n(see https://github.com/puleos/object-hash/issues/26)\nUse "options.replacer" or "options.ignoreUnknown"\n');
            },
            _domwindow: function _domwindow() {
              return r("domwindow");
            },
            _process: function _process() {
              return r("process");
            },
            _timer: function _timer() {
              return r("timer");
            },
            _pipe: function _pipe() {
              return r("pipe");
            },
            _tcp: function _tcp() {
              return r("tcp");
            },
            _udp: function _udp() {
              return r("udp");
            },
            _tty: function _tty() {
              return r("tty");
            },
            _statwatcher: function _statwatcher() {
              return r("statwatcher");
            },
            _securecontext: function _securecontext() {
              return r("securecontext");
            },
            _connection: function _connection() {
              return r("connection");
            },
            _zlib: function _zlib() {
              return r("zlib");
            },
            _context: function _context() {
              return r("context");
            },
            _nodescript: function _nodescript() {
              return r("nodescript");
            },
            _httpparser: function _httpparser() {
              return r("httpparser");
            },
            _dataview: function _dataview() {
              return r("dataview");
            },
            _signal: function _signal() {
              return r("signal");
            },
            _fsevent: function _fsevent() {
              return r("fsevent");
            },
            _tlswrap: function _tlswrap() {
              return r("tlswrap");
            }
          };
        }

        function w() {
          return {
            buf: "",
            write: function write(e) {
              this.buf += e;
            },
            end: function end(e) {
              this.buf += e;
            },
            read: function read() {
              return this.buf;
            }
          };
        }

        var b = e("crypto");
        n = t.exports = d, n.sha1 = function (e) {
          return d(e);
        }, n.keys = function (e) {
          return d(e, {
            excludeValues: !0,
            algorithm: "sha1",
            encoding: "hex"
          });
        }, n.MD5 = function (e) {
          return d(e, {
            algorithm: "md5",
            encoding: "hex"
          });
        }, n.keysMD5 = function (e) {
          return d(e, {
            algorithm: "md5",
            encoding: "hex",
            excludeValues: !0
          });
        };
        var v = b.getHashes ? b.getHashes().slice() : ["sha1", "md5"];
        v.push("passthrough");
        var m = ["buffer", "hex", "binary", "base64"];

        n.writeToStream = function (e, t, n) {
          return "undefined" == typeof n && (n = t, t = {}), t = h(e, t), y(t, n).dispatch(e);
        };
      }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/fake_e8180ef5.js", "/");
    }, {
      buffer: 3,
      crypto: 5,
      lYpoI2: 10
    }],
    2: [function (e, t, n) {
      (function (e, t, r, o, i, u, a, f, s) {
        var c = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        !function (e) {
          "use strict";

          function t(e) {
            var t = e.charCodeAt(0);
            return t === i || t === l ? 62 : t === u || t === d ? 63 : t < a ? -1 : t < a + 10 ? t - a + 26 + 26 : t < s + 26 ? t - s : t < f + 26 ? t - f + 26 : void 0;
          }

          function n(e) {
            function n(e) {
              s[l++] = e;
            }

            var r, i, u, a, f, s;
            if (e.length % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
            var c = e.length;
            f = "=" === e.charAt(c - 2) ? 2 : "=" === e.charAt(c - 1) ? 1 : 0, s = new o(3 * e.length / 4 - f), u = f > 0 ? e.length - 4 : e.length;
            var l = 0;

            for (r = 0, i = 0; r < u; r += 4, i += 3) {
              a = t(e.charAt(r)) << 18 | t(e.charAt(r + 1)) << 12 | t(e.charAt(r + 2)) << 6 | t(e.charAt(r + 3)), n((16711680 & a) >> 16), n((65280 & a) >> 8), n(255 & a);
            }

            return 2 === f ? (a = t(e.charAt(r)) << 2 | t(e.charAt(r + 1)) >> 4, n(255 & a)) : 1 === f && (a = t(e.charAt(r)) << 10 | t(e.charAt(r + 1)) << 4 | t(e.charAt(r + 2)) >> 2, n(a >> 8 & 255), n(255 & a)), s;
          }

          function r(e) {
            function t(e) {
              return c.charAt(e);
            }

            function n(e) {
              return t(e >> 18 & 63) + t(e >> 12 & 63) + t(e >> 6 & 63) + t(63 & e);
            }

            var r,
                o,
                i,
                u = e.length % 3,
                a = "";

            for (r = 0, i = e.length - u; r < i; r += 3) {
              o = (e[r] << 16) + (e[r + 1] << 8) + e[r + 2], a += n(o);
            }

            switch (u) {
              case 1:
                o = e[e.length - 1], a += t(o >> 2), a += t(o << 4 & 63), a += "==";
                break;

              case 2:
                o = (e[e.length - 2] << 8) + e[e.length - 1], a += t(o >> 10), a += t(o >> 4 & 63), a += t(o << 2 & 63), a += "=";
            }

            return a;
          }

          var o = "undefined" != typeof Uint8Array ? Uint8Array : Array,
              i = "+".charCodeAt(0),
              u = "/".charCodeAt(0),
              a = "0".charCodeAt(0),
              f = "a".charCodeAt(0),
              s = "A".charCodeAt(0),
              l = "-".charCodeAt(0),
              d = "_".charCodeAt(0);
          e.toByteArray = n, e.fromByteArray = r;
        }("undefined" == typeof n ? this.base64js = {} : n);
      }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js", "/node_modules/gulp-browserify/node_modules/base64-js/lib");
    }, {
      buffer: 3,
      lYpoI2: 10
    }],
    3: [function (e, t, n) {
      (function (t, r, o, i, u, a, f, s, c) {
        function o(e, t, n) {
          if (!(this instanceof o)) return new o(e, t, n);
          var r = typeof e;
          if ("base64" === t && "string" === r) for (e = N(e); e.length % 4 !== 0;) {
            e += "=";
          }
          var i;
          if ("number" === r) i = F(e);else if ("string" === r) i = o.byteLength(e, t);else {
            if ("object" !== r) throw new Error("First argument needs to be a number, array or string.");
            i = F(e.length);
          }
          var u;
          o._useTypedArrays ? u = o._augment(new Uint8Array(i)) : (u = this, u.length = i, u._isBuffer = !0);
          var a;
          if (o._useTypedArrays && "number" == typeof e.byteLength) u._set(e);else if (O(e)) for (a = 0; a < i; a++) {
            o.isBuffer(e) ? u[a] = e.readUInt8(a) : u[a] = e[a];
          } else if ("string" === r) u.write(e, 0, t);else if ("number" === r && !o._useTypedArrays && !n) for (a = 0; a < i; a++) {
            u[a] = 0;
          }
          return u;
        }

        function l(e, t, n, r) {
          n = Number(n) || 0;
          var i = e.length - n;
          r ? (r = Number(r), r > i && (r = i)) : r = i;
          var u = t.length;
          $(u % 2 === 0, "Invalid hex string"), r > u / 2 && (r = u / 2);

          for (var a = 0; a < r; a++) {
            var f = parseInt(t.substr(2 * a, 2), 16);
            $(!isNaN(f), "Invalid hex string"), e[n + a] = f;
          }

          return o._charsWritten = 2 * a, a;
        }

        function d(e, t, n, r) {
          var i = o._charsWritten = W(V(t), e, n, r);
          return i;
        }

        function h(e, t, n, r) {
          var i = o._charsWritten = W(q(t), e, n, r);
          return i;
        }

        function p(e, t, n, r) {
          return h(e, t, n, r);
        }

        function g(e, t, n, r) {
          var i = o._charsWritten = W(R(t), e, n, r);
          return i;
        }

        function y(e, t, n, r) {
          var i = o._charsWritten = W(P(t), e, n, r);
          return i;
        }

        function w(e, t, n) {
          return 0 === t && n === e.length ? G.fromByteArray(e) : G.fromByteArray(e.slice(t, n));
        }

        function b(e, t, n) {
          var r = "",
              o = "";
          n = Math.min(e.length, n);

          for (var i = t; i < n; i++) {
            e[i] <= 127 ? (r += J(o) + String.fromCharCode(e[i]), o = "") : o += "%" + e[i].toString(16);
          }

          return r + J(o);
        }

        function v(e, t, n) {
          var r = "";
          n = Math.min(e.length, n);

          for (var o = t; o < n; o++) {
            r += String.fromCharCode(e[o]);
          }

          return r;
        }

        function m(e, t, n) {
          return v(e, t, n);
        }

        function _(e, t, n) {
          var r = e.length;
          (!t || t < 0) && (t = 0), (!n || n < 0 || n > r) && (n = r);

          for (var o = "", i = t; i < n; i++) {
            o += H(e[i]);
          }

          return o;
        }

        function E(e, t, n) {
          for (var r = e.slice(t, n), o = "", i = 0; i < r.length; i += 2) {
            o += String.fromCharCode(r[i] + 256 * r[i + 1]);
          }

          return o;
        }

        function I(e, t, n, r) {
          r || ($("boolean" == typeof n, "missing or invalid endian"), $(void 0 !== t && null !== t, "missing offset"), $(t + 1 < e.length, "Trying to read beyond buffer length"));
          var o = e.length;

          if (!(t >= o)) {
            var i;
            return n ? (i = e[t], t + 1 < o && (i |= e[t + 1] << 8)) : (i = e[t] << 8, t + 1 < o && (i |= e[t + 1])), i;
          }
        }

        function A(e, t, n, r) {
          r || ($("boolean" == typeof n, "missing or invalid endian"), $(void 0 !== t && null !== t, "missing offset"), $(t + 3 < e.length, "Trying to read beyond buffer length"));
          var o = e.length;

          if (!(t >= o)) {
            var i;
            return n ? (t + 2 < o && (i = e[t + 2] << 16), t + 1 < o && (i |= e[t + 1] << 8), i |= e[t], t + 3 < o && (i += e[t + 3] << 24 >>> 0)) : (t + 1 < o && (i = e[t + 1] << 16), t + 2 < o && (i |= e[t + 2] << 8), t + 3 < o && (i |= e[t + 3]), i += e[t] << 24 >>> 0), i;
          }
        }

        function B(e, t, n, r) {
          r || ($("boolean" == typeof n, "missing or invalid endian"), $(void 0 !== t && null !== t, "missing offset"), $(t + 1 < e.length, "Trying to read beyond buffer length"));
          var o = e.length;

          if (!(t >= o)) {
            var i = I(e, t, n, !0),
                u = 32768 & i;
            return u ? (65535 - i + 1) * -1 : i;
          }
        }

        function L(e, t, n, r) {
          r || ($("boolean" == typeof n, "missing or invalid endian"), $(void 0 !== t && null !== t, "missing offset"), $(t + 3 < e.length, "Trying to read beyond buffer length"));
          var o = e.length;

          if (!(t >= o)) {
            var i = A(e, t, n, !0),
                u = 2147483648 & i;
            return u ? (4294967295 - i + 1) * -1 : i;
          }
        }

        function U(e, t, n, r) {
          return r || ($("boolean" == typeof n, "missing or invalid endian"), $(t + 3 < e.length, "Trying to read beyond buffer length")), Q.read(e, t, n, 23, 4);
        }

        function x(e, t, n, r) {
          return r || ($("boolean" == typeof n, "missing or invalid endian"), $(t + 7 < e.length, "Trying to read beyond buffer length")), Q.read(e, t, n, 52, 8);
        }

        function S(e, t, n, r, o) {
          o || ($(void 0 !== t && null !== t, "missing value"), $("boolean" == typeof r, "missing or invalid endian"), $(void 0 !== n && null !== n, "missing offset"), $(n + 1 < e.length, "trying to write beyond buffer length"), K(t, 65535));
          var i = e.length;
          if (!(n >= i)) for (var u = 0, a = Math.min(i - n, 2); u < a; u++) {
            e[n + u] = (t & 255 << 8 * (r ? u : 1 - u)) >>> 8 * (r ? u : 1 - u);
          }
        }

        function j(e, t, n, r, o) {
          o || ($(void 0 !== t && null !== t, "missing value"), $("boolean" == typeof r, "missing or invalid endian"), $(void 0 !== n && null !== n, "missing offset"), $(n + 3 < e.length, "trying to write beyond buffer length"), K(t, 4294967295));
          var i = e.length;
          if (!(n >= i)) for (var u = 0, a = Math.min(i - n, 4); u < a; u++) {
            e[n + u] = t >>> 8 * (r ? u : 3 - u) & 255;
          }
        }

        function C(e, t, n, r, o) {
          o || ($(void 0 !== t && null !== t, "missing value"), $("boolean" == typeof r, "missing or invalid endian"), $(void 0 !== n && null !== n, "missing offset"), $(n + 1 < e.length, "Trying to write beyond buffer length"), z(t, 32767, -32768));
          var i = e.length;
          n >= i || (t >= 0 ? S(e, t, n, r, o) : S(e, 65535 + t + 1, n, r, o));
        }

        function k(e, t, n, r, o) {
          o || ($(void 0 !== t && null !== t, "missing value"), $("boolean" == typeof r, "missing or invalid endian"), $(void 0 !== n && null !== n, "missing offset"), $(n + 3 < e.length, "Trying to write beyond buffer length"), z(t, 2147483647, -2147483648));
          var i = e.length;
          n >= i || (t >= 0 ? j(e, t, n, r, o) : j(e, 4294967295 + t + 1, n, r, o));
        }

        function T(e, t, n, r, o) {
          o || ($(void 0 !== t && null !== t, "missing value"), $("boolean" == typeof r, "missing or invalid endian"), $(void 0 !== n && null !== n, "missing offset"), $(n + 3 < e.length, "Trying to write beyond buffer length"), X(t, 3.4028234663852886e38, -3.4028234663852886e38));
          var i = e.length;
          n >= i || Q.write(e, t, n, r, 23, 4);
        }

        function M(e, t, n, r, o) {
          o || ($(void 0 !== t && null !== t, "missing value"), $("boolean" == typeof r, "missing or invalid endian"), $(void 0 !== n && null !== n, "missing offset"), $(n + 7 < e.length, "Trying to write beyond buffer length"), X(t, 1.7976931348623157e308, -1.7976931348623157e308));
          var i = e.length;
          n >= i || Q.write(e, t, n, r, 52, 8);
        }

        function N(e) {
          return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
        }

        function Y(e, t, n) {
          return "number" != typeof e ? n : (e = ~~e, e >= t ? t : e >= 0 ? e : (e += t, e >= 0 ? e : 0));
        }

        function F(e) {
          return e = ~~Math.ceil(+e), e < 0 ? 0 : e;
        }

        function D(e) {
          return (Array.isArray || function (e) {
            return "[object Array]" === Object.prototype.toString.call(e);
          })(e);
        }

        function O(e) {
          return D(e) || o.isBuffer(e) || e && "object" == typeof e && "number" == typeof e.length;
        }

        function H(e) {
          return e < 16 ? "0" + e.toString(16) : e.toString(16);
        }

        function V(e) {
          for (var t = [], n = 0; n < e.length; n++) {
            var r = e.charCodeAt(n);
            if (r <= 127) t.push(e.charCodeAt(n));else {
              var o = n;
              r >= 55296 && r <= 57343 && n++;

              for (var i = encodeURIComponent(e.slice(o, n + 1)).substr(1).split("%"), u = 0; u < i.length; u++) {
                t.push(parseInt(i[u], 16));
              }
            }
          }

          return t;
        }

        function q(e) {
          for (var t = [], n = 0; n < e.length; n++) {
            t.push(255 & e.charCodeAt(n));
          }

          return t;
        }

        function P(e) {
          for (var t, n, r, o = [], i = 0; i < e.length; i++) {
            t = e.charCodeAt(i), n = t >> 8, r = t % 256, o.push(r), o.push(n);
          }

          return o;
        }

        function R(e) {
          return G.toByteArray(e);
        }

        function W(e, t, n, r) {
          for (var o = 0; o < r && !(o + n >= t.length || o >= e.length); o++) {
            t[o + n] = e[o];
          }

          return o;
        }

        function J(e) {
          try {
            return decodeURIComponent(e);
          } catch (t) {
            return String.fromCharCode(65533);
          }
        }

        function K(e, t) {
          $("number" == typeof e, "cannot write a non-number as a number"), $(e >= 0, "specified a negative value for writing an unsigned value"), $(e <= t, "value is larger than maximum value for type"), $(Math.floor(e) === e, "value has a fractional component");
        }

        function z(e, t, n) {
          $("number" == typeof e, "cannot write a non-number as a number"), $(e <= t, "value larger than maximum allowed value"), $(e >= n, "value smaller than minimum allowed value"), $(Math.floor(e) === e, "value has a fractional component");
        }

        function X(e, t, n) {
          $("number" == typeof e, "cannot write a non-number as a number"), $(e <= t, "value larger than maximum allowed value"), $(e >= n, "value smaller than minimum allowed value");
        }

        function $(e, t) {
          if (!e) throw new Error(t || "Failed assertion");
        }

        var G = e("base64-js"),
            Q = e("ieee754");
        n.Buffer = o, n.SlowBuffer = o, n.INSPECT_MAX_BYTES = 50, o.poolSize = 8192, o._useTypedArrays = function () {
          try {
            var e = new ArrayBuffer(0),
                t = new Uint8Array(e);
            return t.foo = function () {
              return 42;
            }, 42 === t.foo() && "function" == typeof t.subarray;
          } catch (n) {
            return !1;
          }
        }(), o.isEncoding = function (e) {
          switch (String(e).toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "binary":
            case "base64":
            case "raw":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return !0;

            default:
              return !1;
          }
        }, o.isBuffer = function (e) {
          return !(null === e || void 0 === e || !e._isBuffer);
        }, o.byteLength = function (e, t) {
          var n;

          switch (e += "", t || "utf8") {
            case "hex":
              n = e.length / 2;
              break;

            case "utf8":
            case "utf-8":
              n = V(e).length;
              break;

            case "ascii":
            case "binary":
            case "raw":
              n = e.length;
              break;

            case "base64":
              n = R(e).length;
              break;

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              n = 2 * e.length;
              break;

            default:
              throw new Error("Unknown encoding");
          }

          return n;
        }, o.concat = function (e, t) {
          if ($(D(e), "Usage: Buffer.concat(list, [totalLength])\nlist should be an Array."), 0 === e.length) return new o(0);
          if (1 === e.length) return e[0];
          var n;
          if ("number" != typeof t) for (t = 0, n = 0; n < e.length; n++) {
            t += e[n].length;
          }
          var r = new o(t),
              i = 0;

          for (n = 0; n < e.length; n++) {
            var u = e[n];
            u.copy(r, i), i += u.length;
          }

          return r;
        }, o.prototype.write = function (e, t, n, r) {
          if (isFinite(t)) isFinite(n) || (r = n, n = void 0);else {
            var o = r;
            r = t, t = n, n = o;
          }
          t = Number(t) || 0;
          var i = this.length - t;
          n ? (n = Number(n), n > i && (n = i)) : n = i, r = String(r || "utf8").toLowerCase();
          var u;

          switch (r) {
            case "hex":
              u = l(this, e, t, n);
              break;

            case "utf8":
            case "utf-8":
              u = d(this, e, t, n);
              break;

            case "ascii":
              u = h(this, e, t, n);
              break;

            case "binary":
              u = p(this, e, t, n);
              break;

            case "base64":
              u = g(this, e, t, n);
              break;

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              u = y(this, e, t, n);
              break;

            default:
              throw new Error("Unknown encoding");
          }

          return u;
        }, o.prototype.toString = function (e, t, n) {
          var r = this;
          if (e = String(e || "utf8").toLowerCase(), t = Number(t) || 0, n = void 0 !== n ? Number(n) : n = r.length, n === t) return "";
          var o;

          switch (e) {
            case "hex":
              o = _(r, t, n);
              break;

            case "utf8":
            case "utf-8":
              o = b(r, t, n);
              break;

            case "ascii":
              o = v(r, t, n);
              break;

            case "binary":
              o = m(r, t, n);
              break;

            case "base64":
              o = w(r, t, n);
              break;

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              o = E(r, t, n);
              break;

            default:
              throw new Error("Unknown encoding");
          }

          return o;
        }, o.prototype.toJSON = function () {
          return {
            type: "Buffer",
            data: Array.prototype.slice.call(this._arr || this, 0)
          };
        }, o.prototype.copy = function (e, t, n, r) {
          var i = this;

          if (n || (n = 0), r || 0 === r || (r = this.length), t || (t = 0), r !== n && 0 !== e.length && 0 !== i.length) {
            $(r >= n, "sourceEnd < sourceStart"), $(t >= 0 && t < e.length, "targetStart out of bounds"), $(n >= 0 && n < i.length, "sourceStart out of bounds"), $(r >= 0 && r <= i.length, "sourceEnd out of bounds"), r > this.length && (r = this.length), e.length - t < r - n && (r = e.length - t + n);
            var u = r - n;
            if (u < 100 || !o._useTypedArrays) for (var a = 0; a < u; a++) {
              e[a + t] = this[a + n];
            } else e._set(this.subarray(n, n + u), t);
          }
        }, o.prototype.slice = function (e, t) {
          var n = this.length;
          if (e = Y(e, n, 0), t = Y(t, n, n), o._useTypedArrays) return o._augment(this.subarray(e, t));

          for (var r = t - e, i = new o(r, void 0, !0), u = 0; u < r; u++) {
            i[u] = this[u + e];
          }

          return i;
        }, o.prototype.get = function (e) {
          return console.log(".get() is deprecated. Access using array indexes instead."), this.readUInt8(e);
        }, o.prototype.set = function (e, t) {
          return console.log(".set() is deprecated. Access using array indexes instead."), this.writeUInt8(e, t);
        }, o.prototype.readUInt8 = function (e, t) {
          if (t || ($(void 0 !== e && null !== e, "missing offset"), $(e < this.length, "Trying to read beyond buffer length")), !(e >= this.length)) return this[e];
        }, o.prototype.readUInt16LE = function (e, t) {
          return I(this, e, !0, t);
        }, o.prototype.readUInt16BE = function (e, t) {
          return I(this, e, !1, t);
        }, o.prototype.readUInt32LE = function (e, t) {
          return A(this, e, !0, t);
        }, o.prototype.readUInt32BE = function (e, t) {
          return A(this, e, !1, t);
        }, o.prototype.readInt8 = function (e, t) {
          if (t || ($(void 0 !== e && null !== e, "missing offset"), $(e < this.length, "Trying to read beyond buffer length")), !(e >= this.length)) {
            var n = 128 & this[e];
            return n ? (255 - this[e] + 1) * -1 : this[e];
          }
        }, o.prototype.readInt16LE = function (e, t) {
          return B(this, e, !0, t);
        }, o.prototype.readInt16BE = function (e, t) {
          return B(this, e, !1, t);
        }, o.prototype.readInt32LE = function (e, t) {
          return L(this, e, !0, t);
        }, o.prototype.readInt32BE = function (e, t) {
          return L(this, e, !1, t);
        }, o.prototype.readFloatLE = function (e, t) {
          return U(this, e, !0, t);
        }, o.prototype.readFloatBE = function (e, t) {
          return U(this, e, !1, t);
        }, o.prototype.readDoubleLE = function (e, t) {
          return x(this, e, !0, t);
        }, o.prototype.readDoubleBE = function (e, t) {
          return x(this, e, !1, t);
        }, o.prototype.writeUInt8 = function (e, t, n) {
          n || ($(void 0 !== e && null !== e, "missing value"), $(void 0 !== t && null !== t, "missing offset"), $(t < this.length, "trying to write beyond buffer length"), K(e, 255)), t >= this.length || (this[t] = e);
        }, o.prototype.writeUInt16LE = function (e, t, n) {
          S(this, e, t, !0, n);
        }, o.prototype.writeUInt16BE = function (e, t, n) {
          S(this, e, t, !1, n);
        }, o.prototype.writeUInt32LE = function (e, t, n) {
          j(this, e, t, !0, n);
        }, o.prototype.writeUInt32BE = function (e, t, n) {
          j(this, e, t, !1, n);
        }, o.prototype.writeInt8 = function (e, t, n) {
          n || ($(void 0 !== e && null !== e, "missing value"), $(void 0 !== t && null !== t, "missing offset"), $(t < this.length, "Trying to write beyond buffer length"), z(e, 127, -128)), t >= this.length || (e >= 0 ? this.writeUInt8(e, t, n) : this.writeUInt8(255 + e + 1, t, n));
        }, o.prototype.writeInt16LE = function (e, t, n) {
          C(this, e, t, !0, n);
        }, o.prototype.writeInt16BE = function (e, t, n) {
          C(this, e, t, !1, n);
        }, o.prototype.writeInt32LE = function (e, t, n) {
          k(this, e, t, !0, n);
        }, o.prototype.writeInt32BE = function (e, t, n) {
          k(this, e, t, !1, n);
        }, o.prototype.writeFloatLE = function (e, t, n) {
          T(this, e, t, !0, n);
        }, o.prototype.writeFloatBE = function (e, t, n) {
          T(this, e, t, !1, n);
        }, o.prototype.writeDoubleLE = function (e, t, n) {
          M(this, e, t, !0, n);
        }, o.prototype.writeDoubleBE = function (e, t, n) {
          M(this, e, t, !1, n);
        }, o.prototype.fill = function (e, t, n) {
          if (e || (e = 0), t || (t = 0), n || (n = this.length), "string" == typeof e && (e = e.charCodeAt(0)), $("number" == typeof e && !isNaN(e), "value is not a number"), $(n >= t, "end < start"), n !== t && 0 !== this.length) {
            $(t >= 0 && t < this.length, "start out of bounds"), $(n >= 0 && n <= this.length, "end out of bounds");

            for (var r = t; r < n; r++) {
              this[r] = e;
            }
          }
        }, o.prototype.inspect = function () {
          for (var e = [], t = this.length, r = 0; r < t; r++) {
            if (e[r] = H(this[r]), r === n.INSPECT_MAX_BYTES) {
              e[r + 1] = "...";
              break;
            }
          }

          return "<Buffer " + e.join(" ") + ">";
        }, o.prototype.toArrayBuffer = function () {
          if ("undefined" != typeof Uint8Array) {
            if (o._useTypedArrays) return new o(this).buffer;

            for (var e = new Uint8Array(this.length), t = 0, n = e.length; t < n; t += 1) {
              e[t] = this[t];
            }

            return e.buffer;
          }

          throw new Error("Buffer.toArrayBuffer not supported in this browser");
        };
        var Z = o.prototype;

        o._augment = function (e) {
          return e._isBuffer = !0, e._get = e.get, e._set = e.set, e.get = Z.get, e.set = Z.set, e.write = Z.write, e.toString = Z.toString, e.toLocaleString = Z.toString, e.toJSON = Z.toJSON, e.copy = Z.copy, e.slice = Z.slice, e.readUInt8 = Z.readUInt8, e.readUInt16LE = Z.readUInt16LE, e.readUInt16BE = Z.readUInt16BE, e.readUInt32LE = Z.readUInt32LE, e.readUInt32BE = Z.readUInt32BE, e.readInt8 = Z.readInt8, e.readInt16LE = Z.readInt16LE, e.readInt16BE = Z.readInt16BE, e.readInt32LE = Z.readInt32LE, e.readInt32BE = Z.readInt32BE, e.readFloatLE = Z.readFloatLE, e.readFloatBE = Z.readFloatBE, e.readDoubleLE = Z.readDoubleLE, e.readDoubleBE = Z.readDoubleBE, e.writeUInt8 = Z.writeUInt8, e.writeUInt16LE = Z.writeUInt16LE, e.writeUInt16BE = Z.writeUInt16BE, e.writeUInt32LE = Z.writeUInt32LE, e.writeUInt32BE = Z.writeUInt32BE, e.writeInt8 = Z.writeInt8, e.writeInt16LE = Z.writeInt16LE, e.writeInt16BE = Z.writeInt16BE, e.writeInt32LE = Z.writeInt32LE, e.writeInt32BE = Z.writeInt32BE, e.writeFloatLE = Z.writeFloatLE, e.writeFloatBE = Z.writeFloatBE, e.writeDoubleLE = Z.writeDoubleLE, e.writeDoubleBE = Z.writeDoubleBE, e.fill = Z.fill, e.inspect = Z.inspect, e.toArrayBuffer = Z.toArrayBuffer, e;
        };
      }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/buffer/index.js", "/node_modules/gulp-browserify/node_modules/buffer");
    }, {
      "base64-js": 2,
      buffer: 3,
      ieee754: 11,
      lYpoI2: 10
    }],
    4: [function (e, t, n) {
      (function (n, r, o, i, u, a, f, s, c) {
        function l(e, t) {
          if (e.length % p !== 0) {
            var n = e.length + (p - e.length % p);
            e = o.concat([e, g], n);
          }

          for (var r = [], i = t ? e.readInt32BE : e.readInt32LE, u = 0; u < e.length; u += p) {
            r.push(i.call(e, u));
          }

          return r;
        }

        function d(e, t, n) {
          for (var r = new o(t), i = n ? r.writeInt32BE : r.writeInt32LE, u = 0; u < e.length; u++) {
            i.call(r, e[u], 4 * u, !0);
          }

          return r;
        }

        function h(e, t, n, r) {
          o.isBuffer(e) || (e = new o(e));
          var i = t(l(e, r), e.length * y);
          return d(i, n, r);
        }

        var o = e("buffer").Buffer,
            p = 4,
            g = new o(p);
        g.fill(0);
        var y = 8;
        t.exports = {
          hash: h
        };
      }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, {
      buffer: 3,
      lYpoI2: 10
    }],
    5: [function (e, t, n) {
      (function (t, r, o, i, u, a, f, s, c) {
        function l(e, t, n) {
          o.isBuffer(t) || (t = new o(t)), o.isBuffer(n) || (n = new o(n)), t.length > m ? t = e(t) : t.length < m && (t = o.concat([t, _], m));

          for (var r = new o(m), i = new o(m), u = 0; u < m; u++) {
            r[u] = 54 ^ t[u], i[u] = 92 ^ t[u];
          }

          var a = e(o.concat([r, n]));
          return e(o.concat([i, a]));
        }

        function d(e, t) {
          e = e || "sha1";
          var n = v[e],
              r = [],
              i = 0;
          return n || h("algorithm:", e, "is not yet supported"), {
            update: function update(e) {
              return o.isBuffer(e) || (e = new o(e)), r.push(e), i += e.length, this;
            },
            digest: function digest(e) {
              var i = o.concat(r),
                  u = t ? l(n, t, i) : n(i);
              return r = null, e ? u.toString(e) : u;
            }
          };
        }

        function h() {
          var e = [].slice.call(arguments).join(" ");
          throw new Error([e, "we accept pull requests", "http://github.com/dominictarr/crypto-browserify"].join("\n"));
        }

        function p(e, t) {
          for (var n in e) {
            t(e[n], n);
          }
        }

        var o = e("buffer").Buffer,
            g = e("./sha"),
            y = e("./sha256"),
            w = e("./rng"),
            b = e("./md5"),
            v = {
          sha1: g,
          sha256: y,
          md5: b
        },
            m = 64,
            _ = new o(m);

        _.fill(0), n.createHash = function (e) {
          return d(e);
        }, n.createHmac = function (e, t) {
          return d(e, t);
        }, n.randomBytes = function (e, t) {
          if (!t || !t.call) return new o(w(e));

          try {
            t.call(this, void 0, new o(w(e)));
          } catch (n) {
            t(n);
          }
        }, p(["createCredentials", "createCipher", "createCipheriv", "createDecipher", "createDecipheriv", "createSign", "createVerify", "createDiffieHellman", "pbkdf2"], function (e) {
          n[e] = function () {
            h("sorry,", e, "is not implemented yet");
          };
        });
      }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, {
      "./md5": 6,
      "./rng": 7,
      "./sha": 8,
      "./sha256": 9,
      buffer: 3,
      lYpoI2: 10
    }],
    6: [function (e, t, n) {
      (function (n, r, o, i, u, a, f, s, c) {
        function l(e, t) {
          e[t >> 5] |= 128 << t % 32, e[(t + 64 >>> 9 << 4) + 14] = t;

          for (var n = 1732584193, r = -271733879, o = -1732584194, i = 271733878, u = 0; u < e.length; u += 16) {
            var a = n,
                f = r,
                s = o,
                c = i;
            n = h(n, r, o, i, e[u + 0], 7, -680876936), i = h(i, n, r, o, e[u + 1], 12, -389564586), o = h(o, i, n, r, e[u + 2], 17, 606105819), r = h(r, o, i, n, e[u + 3], 22, -1044525330), n = h(n, r, o, i, e[u + 4], 7, -176418897), i = h(i, n, r, o, e[u + 5], 12, 1200080426), o = h(o, i, n, r, e[u + 6], 17, -1473231341), r = h(r, o, i, n, e[u + 7], 22, -45705983), n = h(n, r, o, i, e[u + 8], 7, 1770035416), i = h(i, n, r, o, e[u + 9], 12, -1958414417), o = h(o, i, n, r, e[u + 10], 17, -42063), r = h(r, o, i, n, e[u + 11], 22, -1990404162), n = h(n, r, o, i, e[u + 12], 7, 1804603682), i = h(i, n, r, o, e[u + 13], 12, -40341101), o = h(o, i, n, r, e[u + 14], 17, -1502002290), r = h(r, o, i, n, e[u + 15], 22, 1236535329), n = p(n, r, o, i, e[u + 1], 5, -165796510), i = p(i, n, r, o, e[u + 6], 9, -1069501632), o = p(o, i, n, r, e[u + 11], 14, 643717713), r = p(r, o, i, n, e[u + 0], 20, -373897302), n = p(n, r, o, i, e[u + 5], 5, -701558691), i = p(i, n, r, o, e[u + 10], 9, 38016083), o = p(o, i, n, r, e[u + 15], 14, -660478335), r = p(r, o, i, n, e[u + 4], 20, -405537848), n = p(n, r, o, i, e[u + 9], 5, 568446438), i = p(i, n, r, o, e[u + 14], 9, -1019803690), o = p(o, i, n, r, e[u + 3], 14, -187363961), r = p(r, o, i, n, e[u + 8], 20, 1163531501), n = p(n, r, o, i, e[u + 13], 5, -1444681467), i = p(i, n, r, o, e[u + 2], 9, -51403784), o = p(o, i, n, r, e[u + 7], 14, 1735328473), r = p(r, o, i, n, e[u + 12], 20, -1926607734), n = g(n, r, o, i, e[u + 5], 4, -378558), i = g(i, n, r, o, e[u + 8], 11, -2022574463), o = g(o, i, n, r, e[u + 11], 16, 1839030562), r = g(r, o, i, n, e[u + 14], 23, -35309556), n = g(n, r, o, i, e[u + 1], 4, -1530992060), i = g(i, n, r, o, e[u + 4], 11, 1272893353), o = g(o, i, n, r, e[u + 7], 16, -155497632), r = g(r, o, i, n, e[u + 10], 23, -1094730640), n = g(n, r, o, i, e[u + 13], 4, 681279174), i = g(i, n, r, o, e[u + 0], 11, -358537222), o = g(o, i, n, r, e[u + 3], 16, -722521979), r = g(r, o, i, n, e[u + 6], 23, 76029189), n = g(n, r, o, i, e[u + 9], 4, -640364487), i = g(i, n, r, o, e[u + 12], 11, -421815835), o = g(o, i, n, r, e[u + 15], 16, 530742520), r = g(r, o, i, n, e[u + 2], 23, -995338651), n = y(n, r, o, i, e[u + 0], 6, -198630844), i = y(i, n, r, o, e[u + 7], 10, 1126891415), o = y(o, i, n, r, e[u + 14], 15, -1416354905), r = y(r, o, i, n, e[u + 5], 21, -57434055), n = y(n, r, o, i, e[u + 12], 6, 1700485571), i = y(i, n, r, o, e[u + 3], 10, -1894986606), o = y(o, i, n, r, e[u + 10], 15, -1051523), r = y(r, o, i, n, e[u + 1], 21, -2054922799), n = y(n, r, o, i, e[u + 8], 6, 1873313359), i = y(i, n, r, o, e[u + 15], 10, -30611744), o = y(o, i, n, r, e[u + 6], 15, -1560198380), r = y(r, o, i, n, e[u + 13], 21, 1309151649), n = y(n, r, o, i, e[u + 4], 6, -145523070), i = y(i, n, r, o, e[u + 11], 10, -1120210379), o = y(o, i, n, r, e[u + 2], 15, 718787259), r = y(r, o, i, n, e[u + 9], 21, -343485551), n = w(n, a), r = w(r, f), o = w(o, s), i = w(i, c);
          }

          return Array(n, r, o, i);
        }

        function d(e, t, n, r, o, i) {
          return w(b(w(w(t, e), w(r, i)), o), n);
        }

        function h(e, t, n, r, o, i, u) {
          return d(t & n | ~t & r, e, t, o, i, u);
        }

        function p(e, t, n, r, o, i, u) {
          return d(t & r | n & ~r, e, t, o, i, u);
        }

        function g(e, t, n, r, o, i, u) {
          return d(t ^ n ^ r, e, t, o, i, u);
        }

        function y(e, t, n, r, o, i, u) {
          return d(n ^ (t | ~r), e, t, o, i, u);
        }

        function w(e, t) {
          var n = (65535 & e) + (65535 & t),
              r = (e >> 16) + (t >> 16) + (n >> 16);
          return r << 16 | 65535 & n;
        }

        function b(e, t) {
          return e << t | e >>> 32 - t;
        }

        var v = e("./helpers");

        t.exports = function (e) {
          return v.hash(e, l, 16);
        };
      }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, {
      "./helpers": 4,
      buffer: 3,
      lYpoI2: 10
    }],
    7: [function (e, t, n) {
      (function (e, n, r, o, i, u, a, f, s) {
        !function () {
          var e,
              n,
              r = this;
          e = function e(_e) {
            for (var t, t, n = new Array(_e), r = 0; r < _e; r++) {
              0 == (3 & r) && (t = 4294967296 * Math.random()), n[r] = t >>> ((3 & r) << 3) & 255;
            }

            return n;
          }, r.crypto && crypto.getRandomValues && (n = function n(e) {
            var t = new Uint8Array(e);
            return crypto.getRandomValues(t), t;
          }), t.exports = n || e;
        }();
      }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, {
      buffer: 3,
      lYpoI2: 10
    }],
    8: [function (e, t, n) {
      (function (n, r, o, i, u, a, f, s, c) {
        function l(e, t) {
          e[t >> 5] |= 128 << 24 - t % 32, e[(t + 64 >> 9 << 4) + 15] = t;

          for (var n = Array(80), r = 1732584193, o = -271733879, i = -1732584194, u = 271733878, a = -1009589776, f = 0; f < e.length; f += 16) {
            for (var s = r, c = o, l = i, y = u, w = a, b = 0; b < 80; b++) {
              b < 16 ? n[b] = e[f + b] : n[b] = g(n[b - 3] ^ n[b - 8] ^ n[b - 14] ^ n[b - 16], 1);
              var v = p(p(g(r, 5), d(b, o, i, u)), p(p(a, n[b]), h(b)));
              a = u, u = i, i = g(o, 30), o = r, r = v;
            }

            r = p(r, s), o = p(o, c), i = p(i, l), u = p(u, y), a = p(a, w);
          }

          return Array(r, o, i, u, a);
        }

        function d(e, t, n, r) {
          return e < 20 ? t & n | ~t & r : e < 40 ? t ^ n ^ r : e < 60 ? t & n | t & r | n & r : t ^ n ^ r;
        }

        function h(e) {
          return e < 20 ? 1518500249 : e < 40 ? 1859775393 : e < 60 ? -1894007588 : -899497514;
        }

        function p(e, t) {
          var n = (65535 & e) + (65535 & t),
              r = (e >> 16) + (t >> 16) + (n >> 16);
          return r << 16 | 65535 & n;
        }

        function g(e, t) {
          return e << t | e >>> 32 - t;
        }

        var y = e("./helpers");

        t.exports = function (e) {
          return y.hash(e, l, 20, !0);
        };
      }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, {
      "./helpers": 4,
      buffer: 3,
      lYpoI2: 10
    }],
    9: [function (e, t, n) {
      (function (n, r, o, i, u, a, f, s, c) {
        var l = e("./helpers"),
            d = function d(e, t) {
          var n = (65535 & e) + (65535 & t),
              r = (e >> 16) + (t >> 16) + (n >> 16);
          return r << 16 | 65535 & n;
        },
            h = function h(e, t) {
          return e >>> t | e << 32 - t;
        },
            p = function p(e, t) {
          return e >>> t;
        },
            g = function g(e, t, n) {
          return e & t ^ ~e & n;
        },
            y = function y(e, t, n) {
          return e & t ^ e & n ^ t & n;
        },
            w = function w(e) {
          return h(e, 2) ^ h(e, 13) ^ h(e, 22);
        },
            b = function b(e) {
          return h(e, 6) ^ h(e, 11) ^ h(e, 25);
        },
            v = function v(e) {
          return h(e, 7) ^ h(e, 18) ^ p(e, 3);
        },
            m = function m(e) {
          return h(e, 17) ^ h(e, 19) ^ p(e, 10);
        },
            _ = function _(e, t) {
          var n,
              r,
              o,
              i,
              u,
              a,
              f,
              s,
              c,
              l,
              h,
              p,
              _ = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298),
              E = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225),
              I = new Array(64);

          e[t >> 5] |= 128 << 24 - t % 32, e[(t + 64 >> 9 << 4) + 15] = t;

          for (var c = 0; c < e.length; c += 16) {
            n = E[0], r = E[1], o = E[2], i = E[3], u = E[4], a = E[5], f = E[6], s = E[7];

            for (var l = 0; l < 64; l++) {
              l < 16 ? I[l] = e[l + c] : I[l] = d(d(d(m(I[l - 2]), I[l - 7]), v(I[l - 15])), I[l - 16]), h = d(d(d(d(s, b(u)), g(u, a, f)), _[l]), I[l]), p = d(w(n), y(n, r, o)), s = f, f = a, a = u, u = d(i, h), i = o, o = r, r = n, n = d(h, p);
            }

            E[0] = d(n, E[0]), E[1] = d(r, E[1]), E[2] = d(o, E[2]), E[3] = d(i, E[3]), E[4] = d(u, E[4]), E[5] = d(a, E[5]), E[6] = d(f, E[6]), E[7] = d(s, E[7]);
          }

          return E;
        };

        t.exports = function (e) {
          return l.hash(e, _, 32, !0);
        };
      }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, {
      "./helpers": 4,
      buffer: 3,
      lYpoI2: 10
    }],
    10: [function (e, t, n) {
      (function (e, n, r, o, i, u, a, f, s) {
        function c() {}

        var e = t.exports = {};
        e.nextTick = function () {
          var e = "undefined" != typeof window && window.setImmediate,
              t = "undefined" != typeof window && window.postMessage && window.addEventListener;
          if (e) return function (e) {
            return window.setImmediate(e);
          };

          if (t) {
            var n = [];
            return window.addEventListener("message", function (e) {
              var t = e.source;

              if ((t === window || null === t) && "process-tick" === e.data && (e.stopPropagation(), n.length > 0)) {
                var r = n.shift();
                r();
              }
            }, !0), function (e) {
              n.push(e), window.postMessage("process-tick", "*");
            };
          }

          return function (e) {
            setTimeout(e, 0);
          };
        }(), e.title = "browser", e.browser = !0, e.env = {}, e.argv = [], e.on = c, e.addListener = c, e.once = c, e.off = c, e.removeListener = c, e.removeAllListeners = c, e.emit = c, e.binding = function (e) {
          throw new Error("process.binding is not supported");
        }, e.cwd = function () {
          return "/";
        }, e.chdir = function (e) {
          throw new Error("process.chdir is not supported");
        };
      }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/process/browser.js", "/node_modules/gulp-browserify/node_modules/process");
    }, {
      buffer: 3,
      lYpoI2: 10
    }],
    11: [function (e, t, n) {
      (function (e, t, r, o, i, u, a, f, s) {
        n.read = function (e, t, n, r, o) {
          var i,
              u,
              a = 8 * o - r - 1,
              f = (1 << a) - 1,
              s = f >> 1,
              c = -7,
              l = n ? o - 1 : 0,
              d = n ? -1 : 1,
              h = e[t + l];

          for (l += d, i = h & (1 << -c) - 1, h >>= -c, c += a; c > 0; i = 256 * i + e[t + l], l += d, c -= 8) {
            ;
          }

          for (u = i & (1 << -c) - 1, i >>= -c, c += r; c > 0; u = 256 * u + e[t + l], l += d, c -= 8) {
            ;
          }

          if (0 === i) i = 1 - s;else {
            if (i === f) return u ? NaN : (h ? -1 : 1) * (1 / 0);
            u += Math.pow(2, r), i -= s;
          }
          return (h ? -1 : 1) * u * Math.pow(2, i - r);
        }, n.write = function (e, t, n, r, o, i) {
          var u,
              a,
              f,
              s = 8 * i - o - 1,
              c = (1 << s) - 1,
              l = c >> 1,
              d = 23 === o ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
              h = r ? 0 : i - 1,
              p = r ? 1 : -1,
              g = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;

          for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, u = c) : (u = Math.floor(Math.log(t) / Math.LN2), t * (f = Math.pow(2, -u)) < 1 && (u--, f *= 2), t += u + l >= 1 ? d / f : d * Math.pow(2, 1 - l), t * f >= 2 && (u++, f /= 2), u + l >= c ? (a = 0, u = c) : u + l >= 1 ? (a = (t * f - 1) * Math.pow(2, o), u += l) : (a = t * Math.pow(2, l - 1) * Math.pow(2, o), u = 0)); o >= 8; e[n + h] = 255 & a, h += p, a /= 256, o -= 8) {
            ;
          }

          for (u = u << o | a, s += o; s > 0; e[n + h] = 255 & u, h += p, u /= 256, s -= 8) {
            ;
          }

          e[n + h - p] |= 128 * g;
        };
      }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/ieee754/index.js", "/node_modules/ieee754");
    }, {
      buffer: 3,
      lYpoI2: 10
    }]
  }, {}, [1])(1);
});